import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import './calculadora.scss'

import { Button, Input, MaskData, Modal } from '../../../components'
import { getIp, modalAlertaInfo, modalClose } from '../../../layout/redux/layoutActions'
import { AtualizarAssinaturaContaXD, calculadoraContaEmpresarial, listaPeriodos, listarAtivos, setAtivos } from '../../minhasAssinaturas/redux/minhasAssinaturasActions'

//utilização em vez de input para usar na calculadora e não correr risco de impactar outros lugares
import { Input2 } from '../../../components/form/input2/input2';

export default () => {
  const dispatch = useDispatch()
  const { sistema, usuario } = useSelector(state => state.layoutState)
  const { assinatura, listas, ativos, avaliacoes } = useSelector(state=> state.minhasAssinaturasState)
  const nls = require(`../../minhasAssinaturas/nls/${sistema?.idioma}.json`)
  const nlsPopup = require(`../../../layout/nlsPopup/${sistema?.idioma}.json`)
  const [form, setForm] = useState({periodo: {}})
    const [avisoLimiteProjetos, setAvisoLimiteProjetos] = useState(false)

  useEffect(()=> {
    dispatch(getIp())
  }, [])

  useEffect(()=> {
    if (listas?.periodos.length) {
      const list = listas?.periodos.find(f=> f.id === 4)
      setForm({...form, periodo: list})
    }
  }, [listas?.periodos])

  useEffect(()=> {
    const idioma = sistema.idiomaIdValue ? sistema.idiomaIdValue : sistema.idiomaIdValueGet
    const consumoConta = sistema.consumoConta ? sistema.consumoConta : {}
    if ( idioma ) {
      dispatch(listaPeriodos({idioma}))
      dispatch(listarAtivos({consumoConta, moeda: sistema.moeda, tipo: 'CE', status: 'init', idioma}))
    }
  }, [sistema])

  const handleChangeOLD = e => {
    if (sistema.moeda) {
      const listaAtivos = ativos.map(a=> a.id === e.id ? {...a, ...e} : a )
      dispatch(setAtivos(e))
      dispatch(calculadoraContaEmpresarial({ativos: listaAtivos, moeda: sistema.moeda}))
    }
  }

  
  const handleChange = e => {
    if (sistema.moeda) {
      const ehProjetoPersonalizado = Number(e.id) === 1;
      const excedeuLimite = ehProjetoPersonalizado &&
        e.quantidadeDesejada !== '' &&
        Number(e.quantidadeDesejada) > 5;

      if (ehProjetoPersonalizado) {
        if (excedeuLimite) {
          setAvisoLimiteProjetos(true);
        } else if (
          e.quantidadeDesejada !== '' &&
          Number(e.quantidadeDesejada) < 5
        ) {
          setAvisoLimiteProjetos(false);
        }
      }

      const quantidadeDesejada = excedeuLimite
        ? 5
        : e.quantidadeDesejada;

      const ativoAtualizado = {
        ...e,
        quantidadeDesejada
      };

      // Atualiza o Redux sem permitir projetos acima de 5.
      // Preserva valores temporariamente vazios durante a edição.
      const listaAtivos = ativos.map(a =>
        a.id === e.id
          ? { ...a, quantidadeDesejada }
          : a
      );

      dispatch(setAtivos(ativoAtualizado));

      // Valida os valores enviados para o cálculo.
      const listaAtivosValidada = listaAtivos.map(a => {
        if (a.id === e.id) {
          let quantidade = Number(quantidadeDesejada);

          if (isNaN(quantidade)) {
            quantidade = a.id <= 2 ? a.id : 0;
          }

          if (a.id <= 2) {
            const maximo = Number(a.id) === 1 ? 5 : 1000;
            quantidade = Math.max(a.id, Math.min(quantidade, maximo));
          } else {
            quantidade = Math.max(0, Math.min(quantidade, 1000));
          }

          return { ...a, quantidadeDesejada: quantidade };
        }

        return a;
      });

      dispatch(calculadoraContaEmpresarial({
        ativos: listaAtivosValidada,
        moeda: sistema.moeda
      }));
    }
  }


  const handleCancelar = e => {
    dispatch(modalClose())
  }

  const handleConcordar = e => {
    console.warn(e, 'handleConcordar');

    const params = {
      idPeriodo: e.periodo.id,
      moeda: sistema.moeda,
      dataAgendadaAlteracao: assinatura.dataRenovacaoAssinatura,
      ativos: [...ativos, {
        descricao: "Avaliações mensais",
        id: 6,
        quantidadeDesejada: avaliacoes.totalQueriesSemQueryPura30,
        valor: avaliacoes.totalQueriesSemQueryPura30
      }]
    }
    dispatch(AtualizarAssinaturaContaXD(params, nlsPopup))
  }
  
  const handleSalvar = e => {
    console.warn(e, 'assinaturas-alterar-projeto');
    dispatch(modalAlertaInfo({
      ...nlsPopup['1'], 
      btnAction: ()=> handleConcordar(e, 'assinaturas-economizar'),
      show: true,
      textos: {
        DataRenovacaoAssinatura: MaskData(assinatura.dataRenovacaoAssinatura, 'DD/MM/YYYY', sistema.idioma),
      }
    }))
    handleCancelar()
  }
  
  const handleChangePeriodo = e => {
    setForm({...form, periodo: e})
  }
  
  const valorTotal = e => {
    const val = e?.find(f=> Number(f.id) === Number(form.periodo.id))
    return val?.valormensal
  }

  // === Tooltip helper: mapeia id do ativo -> chave do nls ===
  const tooltipKeyFor = (id) => {
    switch (Number(id)) {
      case 1: return 'projetos';         // Projetos personalizados
      case 2: return 'empresas';
      case 3: return 'estabelecimentos';
      case 4: return 'produtos';
      case 5: return 'usuarios';
      case 6: return 'feedbacks';        // Avaliações/feedbacks mensais
      default: return null;
    }
  };
  
  return (
    <div className='box-assinaturas-adquirir-ativos'>
        <div className='periodos-lista'>
          <strong>{nls.selecionePeriodo}</strong>
          <div>
            {listas?.periodos?.map(e=> {
              return <div key={e.id}>
                <Button
                  type='btn circle'
                  color={form?.periodo?.id === e.id ? 'primary' : 'default'}
                  size='small'
                  onClick={()=> handleChangePeriodo(e)}
                >{e.descricao}</Button>
              </div>
            })}
          </div>
        </div>
        <div className='ativos-lista-title'>
          <h5>{nls.adicionarAtivos}</h5>
        </div>
        <div className='ativos-lista'>
          {ativos.map(e=> {
            const min = e.id <= 2 ? e.id : 0
            const max = 1000
            return <div key={e.id} className='ativos-lista-item'>
              <div className='ativos-lista-item-info'>
                <span className='has-tooltip'>
                  <strong>{e.descricao}</strong>
                  {tooltipKeyFor(e.id) && (
                    <span className='tip'>
                      {nls[tooltipKeyFor(e.id)]}
                    </span>
                  )}
                                </span>
                {Number(e.id) === 1 && avisoLimiteProjetos && (
                  <small className='aviso-limite-projetos' role='alert'>
                    {nls.limiteProjetosPersonalizados}
                  </small>
                )}
              </div>
              <div className='ativos-lista-item-input'>
                  <Input2 
                    type='number'
                    value={e.quantidadeDesejada}
                    action={a=> handleChange({...e, quantidadeDesejada: a.value})}
                    min={min}
                    max={max}
                  />
              </div>
            </div>
          })}
          <div className='ativos-lista-item'>
            <div className='ativos-lista-item-info'>
              <span className='has-tooltip'>
                <strong>{nls.avaliacoesMensais}</strong>
                <span className='tip'>{nls['feedbacks']}</span>
              </span>
            </div>
            <div className='ativos-lista-item-input'>
              <div className='flag-primary'>
                {avaliacoes.totalQueriesSemQueryPura30}
              </div>
            </div>
          </div>
        </div>
        <div className='ativos-info'>
          <span>{nls.valorTotalAssinatura}: <strong>{valorTotal(avaliacoes.valores)}</strong> 
          {Number(form?.periodo?.id) !== 1 && <> {nls.pormes}</>}
          </span>
        
          {Number(form?.periodo?.id) === 2 && <span>{nls.pagotrimestral}</span>}
          {Number(form?.periodo?.id) === 3 && <span>{nls.pagosemestral}</span>}
          {Number(form?.periodo?.id) === 4 && <span>{nls.pagoanual}</span>}
                
        </div>
      </div>
  )
}


